export default {
    helpText: '半角英数字および記号（. + - _ ）が利用可能です。',
    label: 'ユーザー名',
    title: 'ユーザー名を変更',
};
